var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"voiceDetectionIndicator",staticClass:"s-voiceDetectionIndicator"},[_c('canvas',{ref:"micIndicatorCanvas",attrs:{"width":"44","height":"44"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }